import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ResendConformationModel } from 'src/app/models/login/login.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';

@Component({
  selector: 'app-resend-conformation',
  templateUrl: './resend-conformation.component.html',
  styleUrls: ['./resend-conformation.component.css']
})
export class ResendConformationComponent implements OnInit {
  resendConformation: ResendConformationModel = new ResendConformationModel();
  Loader: boolean = false;
  resendVerificationHideloader: boolean = true;
  resendverificationShowLoader: boolean = false;

  constructor( private router:Router,private route:ActivatedRoute, private _loginService: LoginService,private alertify:AlertifyService) {
    this.resendConformation = new ResendConformationModel();
   }

  ngOnInit() {
  }
  onSubmit() :void{
     if (this.resendConformation.Email == "" || this.resendConformation.Email == null || this.resendConformation.Email == undefined) {
     this.alertify.error("Email is required");
     return;
   }
    this.Loader = true;
    this.resendVerificationHideloader =false;
    this.resendverificationShowLoader =false;
    this._loginService.ResendVerification(this.resendConformation).subscribe(res => {
      var responseData = JSON.parse(res._body);
      if (responseData.isSuccess)
      {
        this.resendConformation = responseData.responseData;
        this.Loader = false;
        this.resendverificationShowLoader = true;
      }
      else 
      {
        this.alertify.error(responseData.responseMessage);
        this.Loader = false;
      }
    })
    

}
}
